













































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import CRUDMixins from "@/mixins/CRUDMixins";
import TransitionMixins from "@/mixins/TransitionMixins";
import BookingCreateGHCBasicInfo from "./Create/BookingCreateGHCBasicInfo.vue";
import BookingCreateCandidateTable from "@/components/Booking/BookingCreateCandidateTable.vue";
import BookingCreateFinalise from "@/components/Booking/BookingCreateFinalise.vue";

import { mapState, mapGetters } from "vuex";
import { STATUSES } from "@/constants/booking";
import { BOOKING_PURPOSES } from "../../../constants/booking";
import { parseDateTime } from "@/utils/dayjs";
import {
  HCS_QUESTION_GROUP_TYPE_PHYSICAL,
  HCS_QUESTION_GROUP_TYPE_PSYCHOLOGICAL
} from "../../../store/modules/ModuleQuestionGroup";

@Component({
  components: {
    "booking-create-ghc-basic-info": BookingCreateGHCBasicInfo,
    BookingCreateCandidateTable,
    BookingCreateFinalise
  },
  computed: {
    ...mapState({
      loading: "loading"
    }),
    ...mapState("RiskProfile", {
      newRiskProfile: "newRiskProfile",
      questionGroups: "questionGroups",
      extraQuestionGroups: "extraQuestionGroups",
      generalHealthChecks: "generalHealthChecks"
    }),
    ...mapState("Auth", {
      business: "activeBusiness"
    }),
    ...mapGetters("Auth", {
      activeRoleDateTimeFormat: "activeRoleDateTimeFormat"
    }),
    ...mapGetters("RiskProfile", {
      enabledRiskProfileItems: "enabledRiskProfileItems",
      bodyPartPreviewItems: "bodyPartPreviewItems",
      availableQuestionGroups: "availableQuestionGroups"
    }),
    ...mapState("ServiceItem", {
      serviceItems: "serviceItems"
    }),
    ...mapState("Booking", {
      booking: "booking"
    }),
    ...mapState("BusinessTag", {
      tagList: "list"
    })
  }
})
export default class BookingCreateGHC extends Mixins(
  CRUDMixins,
  TransitionMixins
) {
  // RiskProfile State
  newRiskProfile!: NewRiskProfile;
  questionGroups!: [];
  extraQuestionGroups!: [];
  generalHealthChecks!: Model[];

  // Business State
  business!: Model;
  activeRoleDateTimeFormat!: string;

  // Booking
  booking!: Booking;

  availableQuestionGroups!: QuestionGroup[];

  serviceItems!: Model[];
  tagList!: Model[];

  // Data
  statuses = STATUSES;
  currentStep = 0;
  questionGroupDescription =
    "Here is the list of the question groups the individual will complete which will provide the relevant information in their report.";
  isBasicInfoValid = false;
  isMounted = false;
  showDialog = false;
  purposes = BOOKING_PURPOSES;

  // Computed
  get riskProfileVal() {
    return this.newRiskProfile;
  }
  set riskProfileVal(v) {
    this.$store.commit("RiskProfile/SET_NEW_RISK_PROFILE", v);
  }

  get physicalQuestionGroups() {
    return this.availableQuestionGroups.filter(
      qg => qg.hcs_type === HCS_QUESTION_GROUP_TYPE_PHYSICAL
    );
  }

  get psychologicalQuestionGroups() {
    return this.availableQuestionGroups.filter(
      qg => qg.hcs_type === HCS_QUESTION_GROUP_TYPE_PSYCHOLOGICAL
    );
  }

  get steps() {
    return [
      {
        title: "Step 1",
        subtitle: "Customise the Health Check",
        description:
          "<p>Please select the question groups to be included in the Health Check. </p><p>Follow step 1, 2, 3 on the screen to complete your customisation.</p>",
        canProceed: () =>
          !!this.booking.ghc_name && !!this.booking.ghc_question_groups?.length
      },
      {
        title: "Step 2",
        subtitle: "Quescreen Bookings"
      },
      {
        title: "Step 3",
        subtitle: "Finalise"
      }
    ];
  }

  async created() {
    this.$store.commit("Booking/RESET_STATE");
    this.$store.commit("BusinessTag/RESET_STATE");
    this.$store.commit("RiskProfile/CLEAR_STATE");

    this.$store.commit("Booking/SET_STATE", {
      key: "booking",
      payload: {
        ...this.booking,
        is_ghc: true,
        ghc_name: "General Health Check",
        purpose: this.purposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
      }
    });
    if (!this.serviceItems.length) {
      await this.$store.dispatch("ServiceItem/fetchList");
    }
    await this.$store.dispatch("RiskProfile/preFetchGHC", {
      params: {
        business_oid: this.business.object_id
      }
    });

    if (!this.tagList.length) {
      await this.$store.dispatch("BusinessTag/fetchList", {
        params: {
          business_oid: this.business.object_id
        }
      });
    }
    this.isMounted = true;
  }

  // Watch
  @Watch("currentStep", { immediate: true })
  watchCurrentStep(newVal) {
    const actions = newVal === 2 ? [""] : ["CREATE", "UPDATE"];
    this.$emit("disable-actions", actions);
  }

  // Watch
  @Watch("booking.candidate_number")
  async candidateNumberChanged() {
    const bookingCandidateCount = this.booking.booking_candidates?.length || 0;
    if (this.booking.candidate_number > bookingCandidateCount) {
      this.booking.booking_candidates?.push({
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        date_of_birth: "",
        additional_services: [],
        source: ""
      });
    } else if (this.booking.candidate_number < bookingCandidateCount) {
      this.booking.booking_candidates?.pop();
    }
  }

  // Methods
  create() {
    this.$store
      .dispatch("Booking/create", {
        ...this.booking,
        status: STATUSES.STATUS_CREATED.key,
        purpose: BOOKING_PURPOSES.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key,
        business_oid: this.business.object_id,
        ghc_question_groups: this.booking.ghc_question_groups?.map(
          (item: Model) => item.object_id
        )
      })
      .then(response => {
        this.$router.push({
          name: "business-booking-read",
          params: {
            bookingOid: response.data.data.object_id
          }
        });
      });
  }

  syncQuestionGroups(value) {
    if (!Array.isArray(this.booking.ghc_question_groups)) {
      this.booking.ghc_question_groups = [];
    }
    const selectedGHC =
      this.generalHealthChecks.find(v => v.object_id === value) ?? [];
    if (selectedGHC) {
      const selectedQuestionGroups = selectedGHC.question_groups?.map(
        v => v.object_id
      );
      this.booking.ghc_question_groups =
        this.availableQuestionGroups?.filter(v =>
          selectedQuestionGroups?.includes(v.object_id)
        ) ?? [];
    }
  }

  formatItemText(item) {
    const dateTimeFormat =
      this.activeRoleDateTimeFormat ?? "YYYY-MM-DD HH:mm:ss";
    const createdAt = parseDateTime(dateTimeFormat, item.created_at);
    return `${item.name} - ${createdAt}`;
  }

  // BeforeDestroy
  beforeDestroy() {
    this.$store.commit("Booking/RESET_STATE");
    this.$store.commit("BusinessTag/RESET_STATE");
    this.$store.commit("RiskProfile/CLEAR_STATE");
  }

  handleFinalise() {
    if (this.showDialog === false) {
      this.showDialog = true;
    } else {
      this.create();
    }
  }
}
